// Shapes of the jsonb collections stored in the owner's row (docs/db.md §3–§5).
// Validated by zod on write; the DB stores as is.
import { z } from 'zod';
import { FORM_LABELS, MEDIA_SOURCES, PARTS_OF_SPEECH, RELATED_KINDS } from './constants.js';
export const PartOfSpeechSchema = z.enum(PARTS_OF_SPEECH);
export const FormLabelSchema = z.enum(FORM_LABELS);
export const RelatedKindSchema = z.enum(RELATED_KINDS);
export const MediaSourceSchema = z.enum(MEDIA_SOURCES);
export const IdSchema = z.string().min(1);
export const RelatedSchema = z.object({
    id: IdSchema,
    kind: RelatedKindSchema,
    // form only: a code, localized in the UI
    label: FormLabelSchema.optional(),
    text: z.string().min(1),
});
export const ForvoMetaSchema = z.object({
    forvoId: z.union([z.string(), z.number()]),
    sex: z.enum(['m', 'f']).nullable(),
    username: z.string().nullable(),
});
export const TtsMetaSchema = z.object({
    model: z.string(),
    voice: z.string(),
});
// Word pronunciation; the only media kind — there are no pictures (docs/project.md §14). New
// pronunciations are TTS; `forvo` is the shape of native-speaker recordings stored earlier,
// which nothing writes any more but which stay playable (docs/db.md §3).
export const MediaSchema = z.discriminatedUnion('source', [
    z.object({
        id: IdSchema,
        kind: z.literal('audio'),
        source: z.literal('forvo'),
        key: z.string().min(1),
        meta: ForvoMetaSchema,
    }),
    z.object({
        id: IdSchema,
        kind: z.literal('audio'),
        source: z.literal('tts'),
        key: z.string().min(1),
        meta: TtsMetaSchema,
    }),
]);
export const TranslationSchema = z.object({
    id: IdSchema,
    text: z.string().min(1), // in base_lang
    contextLabel: z.string().optional(), // in which sense
});
export const ExampleSchema = z.object({
    id: IdSchema,
    text: z.string().min(1), // in lexemes.lang
    translation: z.string(), // in base_lang
    audioKey: z.string().optional(), // TTS of the sentence, key in S3
});
export const RelatedListSchema = z.array(RelatedSchema);
export const MediaListSchema = z.array(MediaSchema);
export const TranslationListSchema = z.array(TranslationSchema);
export const ExampleListSchema = z.array(ExampleSchema);
//# sourceMappingURL=collections.js.map